import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Lock, Shield, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(formData.email, formData.password);
      
      if (result.success) {
        // Check if user is admin
        if (result.user.email === 'admin@unlockbags.com') {
          navigate('/ub-gestione-2026/prenotazioni');
        } else {
          setError('Accesso admin richiesto. Solo personale autorizzato può accedere.');
          setLoading(false);
        }
      } else {
        setError(result.error || 'Credenziali non valide');
        setLoading(false);
      }
    } catch (err) {
      setError('Si è verificato un errore');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-[#141414] border border-[#2A2A2A] w-full max-w-md overflow-hidden"
      >
        {/* Header */}
        <div className="bg-[#FFCC00] p-8 text-[#0A0A0A] text-center">
          <div className="bg-[#0A0A0A]/20 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
            <Shield size={40} />
          </div>
          <h1 className="text-3xl font-heading font-bold mb-2">Admin Portal</h1>
          <p className="text-[#0A0A0A]/70 text-sm">Unlock Bags Management</p>
        </div>

        {/* Form */}
        <div className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Email Admin
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full pl-11 pr-4 py-3 bg-[#0A0A0A] border border-[#2A2A2A] text-white focus:border-[#FFCC00] focus:outline-none transition-all"
                  placeholder="admin@unlockbags.com"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-400 mb-2">
                Password
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full pl-11 pr-4 py-3 bg-[#0A0A0A] border border-[#2A2A2A] text-white focus:border-[#FFCC00] focus:outline-none transition-all"
                  placeholder="••••••••"
                  required
                  minLength={6}
                />
              </div>
            </div>

            {error && (
              <div className="bg-red-500/20 border border-red-500/50 text-red-400 px-4 py-3 text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#FFCC00] text-[#0A0A0A] py-3 font-bold uppercase tracking-wide hover:bg-[#E6B800] transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin" size={20} />
                  Accesso in corso...
                </>
              ) : (
                <>
                  <Shield size={20} />
                  Accedi
                </>
              )}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-500 hover:text-[#FFCC00] transition-colors"
            >
              ← Torna alla Homepage
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
